module.exports = __webpack_public_path__ + "img/br45.edd99aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br45.jpg
// module id = H6Zs
// module chunks = 0